import { api } from '../../../lib/api'

export const GET_SUPERADMIN_REPORT_REQUEST = 'GET_SUPERADMIN_REPORT_REQUEST'
export const GET_SUPERADMIN_REPORT_SUCCESS = 'GET_SUPERADMIN_REPORT_SUCCESS'
export const GET_SUPERADMIN_REPORT_FAILED = 'GET_SUPERADMIN_REPORT_FAILED'

export const getSuperAdminReports = function () {
  return function (dispatch) {
    dispatch({
      type: GET_SUPERADMIN_REPORT_REQUEST
    })
    api.getSuperAdminReports().then(getReportsResponse => {
      dispatch({
        type: GET_SUPERADMIN_REPORT_SUCCESS,
        payload: getReportsResponse
      })

    }).catch(error => {
      dispatch({
        type: GET_SUPERADMIN_REPORT_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/superadmin/get-superadmin-reports.js